import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "swap",
  "use": "swap-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\" id=\"swap\">\r\n    \r\n    <g>\r\n    <path d=\"M15.933 10.6l-1.885 1.885-3.381-3.381v17.563h-2.667v-17.563l-3.38 3.381-1.887-1.885 6.6-6.6 6.6 6.6zM29.267 21.4l-6.6 6.6-6.6-6.6 1.885-1.885 3.383 3.381-0.001-17.563h2.667v17.563l3.381-3.381 1.885 1.885z\" fill=\"rgba(1,142,218,1)\" />\r\n    </g>\r\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol